module.exports = __webpack_public_path__ + "img/reentryHUB-logo@2x.fecdf0a8.png";